import React from "react";
import "./index.scss";

export default function (props: any) {
  const { className, style, info, height} = props;
	
	
  return (
    <div className={`aigc-empty-status ${className}`} style={{...style, height}}>
      <img className="no-data-img" src={require('@/pages/datalab/assets/img/no-data.png')} />
      <div className="no-data-info">{info}</div>
    </div>
		
  );
}